import { useContext } from "react";
import { useQuery } from "react-query";
import { AuthContext } from "src/App/components/Auth";
import { MICROSOFT_GROUP_ID } from "src/constants";
const FIVE_MINUTES = 300000;
const fetchGroupMembershipApi = (auth) => async () => {
    console.log(auth);
    const response = await window.fetch(`https://graph.microsoft.com/v1.0/groups/${MICROSOFT_GROUP_ID}/members?$select=userPrincipalName,displayName,mail,id`, {
        headers: {
            authorization: `Bearer ${auth?.accessToken}`,
        },
    });
    const tokenClaim = auth?.idTokenClaims;
    const data = await response.json();
    const memberIndex = data.value?.findIndex((member) => member.id === auth?.uniqueId);
    console.log(memberIndex, auth?.uniqueId);
    return {
        belongToAdminGroup: memberIndex > -1,
        tokenClaim,
        emailId: tokenClaim.email?.toLowerCase(),
    };
};
const checkGroupAdminAccess = () => useQuery("fetchGroupMembership", fetchGroupMembershipApi(useContext(AuthContext)), {
    staleTime: FIVE_MINUTES,
    retry: false,
});
export default checkGroupAdminAccess;
